<template>
  <div class='EnbPedido'>
    <div class="cont-search">
      <input-search
      placeholder="Número do pedido"
      action="SearchPedidoPainel"
      />
    </div>
    <enb-vazio
    v-if="!Pedidos.length && !GlobalLoading"
    text="Nenhum registro encontrado!"
    />
    <div class="cont" @scroll="run">
      <pedidos-header/>
      <pedidos-list
      v-for="(p, key) in Pedidos"
      :key="key"
      :data="p.pedido"
      :usuario="p.pedido.usuario"
      :endereco="p.endereco"
      :chave="key"
      />
      <div class="bottom">
        <vue-spinner v-if="load" size="45"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PedidosHeader from './header/PedidosHeader'
import PedidosList from './Itens/PedidosList'
import InputSearch from '../Search/InputSearch'
import { VueSpinner } from 'vue3-spinners'
import EnbVazio from '../EnbVazio'
export default {
  name: 'EnbPedido',
  components: { PedidosHeader, PedidosList, InputSearch, VueSpinner, EnbVazio },
  data () {
    return {
      scroll: {
        position: 0,
        height: 1
      },
     load: false
    }
  },
  computed: {
    ...mapGetters(['Pedidos', 'GlobalLoading'])
  },
  methods: {
    ...mapActions(['GetPedidos', 'Loading']),
    run (e) {
      this.scroll = {
        position: (e.target.offsetHeight + e.target.scrollTop),
        height: e.target.scrollHeight
      }
      if((this.scroll.height - this.scroll.position) <= 1) {
        //busca
        this.load = true
        setTimeout(() => {
          this.GetPedidos({
            params: {
              last: this.Pedidos.map(p => p.pedido.id),
              limit: 10
            },
            init: false }).then(() => this.load = false)
        }, 2000)
      }
    }
  },
  created () {
    this.Loading(true)
    this.GetPedidos({ params: { last: [0], limit: 20 }, init: true })
      .then(() => {
        this.Loading(false)
      })
  }
}
</script>

<style scoped>
.EnbPedido {
  width: 100%;
  height: 96%;
}

.cont-search {
  display: flex;
  justify-content: start;
  padding-left: 1%;
}

.cont {
  width: 98%;
  height: 91%;
  padding: 1%;
  padding-bottom: 0;
  padding-top: 0;
  overflow: auto;
}

.bottom {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .EnbPedido {
    height: 70%;
  }
}
</style>
